import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-report-download',
    templateUrl: './report-download.component.html',
    styleUrls: ['./report-download.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [TranslateModule]
})


export class ReportDownloadComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute) {}

  fileNotFound: boolean;
  fileName: string;

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (!params.file) {
        return this.router.navigate(['/dashboard']);
      }
      this.fileName = params.file;
      // Server-generated PDF deep links are deprecated; reports use client-side PDF export.
      this.fileNotFound = true;
    });
  }

}
